import { render, staticRenderFns } from "./HubMenu.vue?vue&type=template&id=5bbaa3ac&scoped=true&"
import script from "./HubMenu.vue?vue&type=script&lang=ts&"
export * from "./HubMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HubMenu.vue?vue&type=style&index=0&id=5bbaa3ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbaa3ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemGroup,VMenu})
